import styled from 'styled-components'

export const Message = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.color.white};
  width: 100%;
  margin: 0 auto;
`

export const Wrapper = styled.div`
  text-align: center;
  margin: 0;
  padding: 12px 32px 12px 17px;
  background: transparent;
`
